import { ContextService } from '../../../services/context_service';
import { Image, Text, View } from '@react-pdf/renderer';
import { parsePdfSub2 } from '../generisch/helper';
import * as React from 'react';
import { SectionStyle } from '../../../helpers/SectionStyle';

export function renderBanner(config: any, style: any, contextService: ContextService, orientation: string): JSX.Element {
    const logoImg = require('../../../img/Logo.jpg');
    const logoUnternehmenImg = contextService.get('UNTERNEHMEN_LOGO_URL');
    const key: string = ((config || {}).report || {}).key || null;
    const styleTitel: React.CSSProperties = { display: 'flex', flexDirection: 'row', alignItems: 'baseline' };
    const styleWrapper: any = {
        ...((style || {}).titleWrapper || {}),
        ...(!!config.titel3 && typeof ((style || {}).titleWrapper || {}).height === 'number' && { height: style.titleWrapper.height + 10 })
    };
    const small: string[] = ['co2_details'];
    const isSmall: boolean = small.indexOf(key) !== -1;
    const titleFont: any = (isSmall && style.titleFontSmall) || style.titleFont || {};
    const titleFont2: any = (isSmall && style.titleFont2Small) || style.titleFont2 || {};
    const titleFont3: any = (isSmall && style.titleFont3Small) || style.titleFont3 || {};
    const titleFont4: any = (isSmall && style.titleFont4Small) || style.titleFont4 || {};
    const sectionId: string = typeof SectionStyle.curPrintSectionId === 'number'
        ? SectionStyle.getCurrentId(true)
        : SectionStyle.getCurrentId();
    const logoSection = sectionId ? require(`../../../img/logo_section_${sectionId}.jpg`) : logoImg;

    return (
        <View style={styleWrapper} fixed>
            {logoUnternehmenImg &&
                <Image src={logoUnternehmenImg} style={style.titleImage3} />
            }
            <Image src={logoSection} style={style.titleImage2} />
            <View style={{
                ...titleFont, ...styleTitel,
                maxWidth: orientation === 'portrait' ? 350 : 550
            }}>
                {!!config.titel0 &&
                    <Text style={{ ...titleFont2, width: 'auto' }}>
                        {parsePdfSub2(config.titel0, titleFont2)}
                    </Text>
                }
            </View>
            {!!config.titel1 &&
                <View style={{ ...titleFont3, ...styleTitel }}>
                    <Text style={{ fontFamily: 'Calibri-Bold', lineHeight: 1.05 }}>
                        →&nbsp;
                    </Text>
                    {parsePdfSub2(config.titel1, titleFont3)}
                    {!!config.titel2 &&
                        <>
                            <Text>:&nbsp;</Text>
                            <Text style={{ ...titleFont4, margin: 0 }}>
                                {parsePdfSub2(config.titel2, titleFont4)}
                            </Text>
                        </>
                    }
                </View>
            }
            {!!config.titel3 &&
                <View style={{ ...titleFont4, ...styleTitel }}>
                    <Text style={{ margin: 0 }}>
                        {parsePdfSub2(config.titel3, titleFont4)}
                    </Text>
                </View>
            }
        </View>
    );
}
